import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core'
import { SwalComponent, SwalPortalTargets } from '@sweetalert2/ngx-sweetalert2'

@Component({
  selector: 'alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss'],
})
export class AlertComponent {
  @Output() confirm = new EventEmitter<void>()
  @ViewChild('swal') swal!: SwalComponent
  @Input() titleTrnKey: string
  @Input() title: string

  @Input() textTrnKey: string
  @Input() text: string

  public constructor(public readonly swalTargets: SwalPortalTargets) {}

  fire() {
    this.swal.fire()
  }
}
